var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1.7893 3.7438 3.43669 3.97191 3.42373 5.42797C3.42061 5.77754 3.3024 6.19792 3.08301 6.74088L1.66224 10.534C1.20597 11.7522 1.82868 13.1092 3.05709 13.5498C4.26234 13.982 5.5898 13.3365 6.03893 12.1374L7.18741 9.10653C7.69252 7.77353 9.66949 8.13555 9.66949 9.56103V12.8344C9.66949 14.1352 10.695 15.1693 12 15.1693C13.305 15.1693 14.3305 14.1353 14.3305 12.8344V9.56103C14.3305 8.13555 16.3075 7.77353 16.8126 9.10653L17.9611 12.1374C18.4102 13.3365 19.7377 13.982 20.9429 13.5498C22.1713 13.1092 22.7941 11.7522 22.3378 10.534L20.917 6.74088C20.6976 6.19792 20.5794 5.77754 20.5763 5.42797C20.5633 3.97191 22.2107 3.7438 23 1",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6051 18.7344C12.3205 18.373 11.7728 18.373 11.4881 18.7344C10.9377 19.4331 10.1822 20.5076 10.1822 21.132C10.1822 22.1637 11.015 23.0001 12.0466 23.0001C13.0782 23.0001 13.911 22.1637 13.911 21.132C13.911 20.5076 13.1554 19.4331 12.6051 18.7344Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparation);
export default __webpack_public_path__ + "static/media/separation.a7f640fdec5b60181d886c6c0a6b80e5.svg";
export { ForwardRef as ReactComponent };